module.exports = __webpack_public_path__ + "img/step1.c00bb1e3.png";